// extracted by mini-css-extract-plugin
export default {"content":"Section_content__Ri7ce","street":"Section_street__OKnaC","places":"Section_places__zKd23"};